import { render, staticRenderFns } from "./BetaalverzoekCheck.vue?vue&type=template&id=708f61ba&scoped=true&"
import script from "./BetaalverzoekCheck.vue?vue&type=script&lang=js&"
export * from "./BetaalverzoekCheck.vue?vue&type=script&lang=js&"
import style0 from "./BetaalverzoekCheck.vue?vue&type=style&index=0&id=708f61ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708f61ba",
  null
  
)

export default component.exports